export default "__VITE_ASSET__841aa0d4__"